import { forwardRef } from 'react'
import BasePassword, {
  PasswordProps as BasePasswordProps,
} from 'antd/lib/input/Password'
import type { InputRef } from 'antd/lib/input/Input'

export interface PasswordProps extends BasePasswordProps {}

export const Password = forwardRef<InputRef, PasswordProps>(
  (props, ref): JSX.Element => (
    <>
      <BasePassword ref={ref} {...props} />
    </>
  )
)
